import UiInpagealertSection from '@/components/sections/ui_inpagealert'
import { WpCustomError } from '@/kontent/content-types'
import { CommonPageProps } from '@/types'
import { getLinkedItems } from '@/utils'
import { useRouter } from 'next/router'
import WebPage from './web_page'

export default function WpCustomErrorPage({
	data,
	mappings,
	preview,
	className,
	rootLayoutClassName,
}: CommonPageProps<WpCustomError>) {
	const { query } = useRouter()

	const DEFAULT_ERROR_MESSAGE_KEY = 'msg_unexpected_error'
	const currentErrorMessageKey =
		(query.msg as string) || DEFAULT_ERROR_MESSAGE_KEY

	const errorMessages = getLinkedItems(
		data.pageResponse.item.elements.error_message,
		data.pageResponse.linkedItems,
	)

	const currentErrorMessage = errorMessages.find(
		(errorMessage) =>
			errorMessage.system.codename === currentErrorMessageKey,
	)

	return (
		<>
			<WebPage
				data={data as any}
				mappings={mappings}
				preview={preview}
				previewData={null}
				className={className}
				rootLayoutClassName={rootLayoutClassName}
				slotAfterTitle={
					currentErrorMessage && (
						<UiInpagealertSection
							className="mb-8"
							linkedItem={currentErrorMessage}
							linkedItems={data.pageResponse.linkedItems}
							mappings={mappings}
						/>
					)
				}
			/>
		</>
	)
}
